<template>
    <div class="nav-big">
        <topPic></topPic>
        <Product></Product>
<!--        <Research></Research>-->
    </div>
</template>

<script>
    import topPic from '../demonstration/top-picture-app.vue'
    import Product from '../demonstration/product-app.vue'
    import Research from '../demonstration/research-app.vue'
    export default {
        name: "demonstration-app",
        components:{
            topPic,Product,Research
        }
    }
</script>

<style scoped lang="scss">
</style>
